import {HTMLAttributes} from "react";
import logoImg from '../../assets/netcomet3.png';
import Navbar from 'react-bootstrap/Navbar';
import { Button, Modal, Nav, Container, Row, ToggleButton, Col, Spinner, Badge } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { useContract } from "../../contexts/ContractContext";
import './Header.scss';
import { useState } from "react";
import {useAuth} from "../../contexts/AuthenticationContext";
import {useNotifications} from "../../contexts/NotificationsContext";

interface HeaderProps extends HTMLAttributes<HTMLDivElement> {
	variant?: string;
}

export function Header({variant, ...rest}: HeaderProps) {
	const history = useHistory();
	const { session } = useAuth();
	const {notificationsUnread} = useNotifications();

	const { radios, showModalContract, loadingModalContract, handleSetContractSelected } = useContract();

	const [radioValue, setRadioValue] = useState(session?.id_contract ? session.id_contract : '');

	const isMobile = window.innerWidth <= 768;

	return(
		<>
			<Navbar collapseOnSelect className="header p1" expand="lg">
				<Container>
					<Link to="/menu">
						<Navbar.Brand>
							<img src={logoImg} alt="Logo Netcomet" width={isMobile ? 130 : 160}/>
							<span className="title">{session?.data.cname.split(" ")[0]}</span>
						</Navbar.Brand>
					</Link>
					<Navbar.Toggle aria-controls="navbarScroll" />
					<Navbar.Collapse id="navbarScroll">
						<Nav
							className="me-auto my-2 my-lg-0"
							navbarScroll
						>
							<Nav.Link className="d-flex w-100 title-icon justify-content-center primary m-0 p-1" onClick={() => history.push('/menu')}>
								<Button className="d-flex w-100 justify-content-center align-items-center" variant="light">
									<span className="material-icons title-icon">home</span>
									Menu
								</Button>
							</Nav.Link>
							<Nav.Link className="d-flex w-100 title-icon justify-content-center m-0 p-1" onClick={() => history.push('/perfil')}>
								<Button className="d-flex w-100 justify-content-center align-items-center" variant="light">
									<span className="material-icons title-icon">face</span>
									Perfil
								</Button>
							</Nav.Link>
							{(('Notification' in window) || ('serviceWorker' in navigator)) && <Nav.Link className="d-flex w-100 title-icon justify-content-center m-0 p-1" onClick={() =>  history.push('/notificacoes')}>
								<div className="d-grid w-100">
									<Button className="d-flex white-space-nowrap w-100 justify-content-center align-items-center" variant="light">
										<>
											{notificationsUnread !== 0 && <Badge className="bg-danger p-1">{notificationsUnread}</Badge>}
											<span className="material-icons title-icon">notifications</span>
										</>
										Notificações
									</Button>
								</div>
							</Nav.Link>}
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>

			<Modal show={showModalContract} onHide={() => {return false}} aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header className="justify-content-center border-bottom-0">
					<Modal.Title id="contained-modal-title-vcenter">
						Selecionar contrato
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="show-grid">
					<Container>
						{loadingModalContract && <div className="justify-content-center align-items-center text-center p-2">
							<Spinner animation="border" role="status"/>
						</div>
						}
						{!loadingModalContract && <div>
							{radios?.map((radio, idx) => (
								<Row key={idx}>
									<Col md={12} sm={12}>
										<ToggleButton
											key={idx}
											id={`radio-${idx}`}
											type="radio"
											variant={''}
											name="radio_contract"
											className="align-items-center mb-3 button-contract"
											value={radio.id_contrato}
											onClick={() => handleSetContractSelected(radio.id_contrato, radio.numero_contrato)}
											checked={radioValue === radio.id_contrato}
											onChange={(e) => setRadioValue(e.currentTarget.value)}
										>
											<Row className='m-2 text-start'>
												<p className='m-0 p-0'><b>Contrato: {radio.numero_contrato} - {radio.status}</b></p>
												<p className='m-0 p-0'><b>{radio.plano}</b></p>
												<p className='m-0 p-0'>{radio.endereco} N°{radio.endereco_numero}, {radio.bairro} - {radio.cidade}</p>
												<p className='m-0 p-0'>Valor R$ {parseFloat(radio.preco).toFixed(2)}</p>
											</Row>
										</ToggleButton>
									</Col>
								</Row>
							))}
						</div>
						}
					</Container>
				</Modal.Body>
			</Modal>
		</>
	);
}
